import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetPartsReturnsInboundCountQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetPartsReturnsInboundCountQuery = { __typename?: 'query_root', delivery_returns_aggregate: { __typename?: 'delivery_returns_aggregate', aggregate?: { __typename?: 'delivery_returns_aggregate_fields', count: number } | null } };


export const GetPartsReturnsInboundCountDocument = gql`
    query GetPartsReturnsInboundCount($customerId: bigint!) {
  delivery_returns_aggregate(
    where: {customer_id: {_eq: $customerId}, status: {_eq: "in_transit"}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPartsReturnsInboundCountQuery__
 *
 * To run a query within a React component, call `useGetPartsReturnsInboundCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsReturnsInboundCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartsReturnsInboundCountQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetPartsReturnsInboundCountQuery(baseOptions: Apollo.QueryHookOptions<GetPartsReturnsInboundCountQuery, GetPartsReturnsInboundCountQueryVariables> & ({ variables: GetPartsReturnsInboundCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartsReturnsInboundCountQuery, GetPartsReturnsInboundCountQueryVariables>(GetPartsReturnsInboundCountDocument, options);
      }
export function useGetPartsReturnsInboundCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartsReturnsInboundCountQuery, GetPartsReturnsInboundCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartsReturnsInboundCountQuery, GetPartsReturnsInboundCountQueryVariables>(GetPartsReturnsInboundCountDocument, options);
        }
// @ts-ignore
export function useGetPartsReturnsInboundCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartsReturnsInboundCountQuery, GetPartsReturnsInboundCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsReturnsInboundCountQuery, GetPartsReturnsInboundCountQueryVariables>;
export function useGetPartsReturnsInboundCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsReturnsInboundCountQuery, GetPartsReturnsInboundCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsReturnsInboundCountQuery | undefined, GetPartsReturnsInboundCountQueryVariables>;
export function useGetPartsReturnsInboundCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsReturnsInboundCountQuery, GetPartsReturnsInboundCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartsReturnsInboundCountQuery, GetPartsReturnsInboundCountQueryVariables>(GetPartsReturnsInboundCountDocument, options);
        }
export type GetPartsReturnsInboundCountQueryHookResult = ReturnType<typeof useGetPartsReturnsInboundCountQuery>;
export type GetPartsReturnsInboundCountLazyQueryHookResult = ReturnType<typeof useGetPartsReturnsInboundCountLazyQuery>;
export type GetPartsReturnsInboundCountSuspenseQueryHookResult = ReturnType<typeof useGetPartsReturnsInboundCountSuspenseQuery>;
export type GetPartsReturnsInboundCountQueryResult = Apollo.QueryResult<GetPartsReturnsInboundCountQuery, GetPartsReturnsInboundCountQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/getPartsReturnsInboundCount.query.gql}
 */
export async function getPartsReturnsInboundCount(
  variables: GetPartsReturnsInboundCountQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetPartsReturnsInboundCountQuery['delivery_returns_aggregate']>
export async function getPartsReturnsInboundCount(
  variables: GetPartsReturnsInboundCountQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetPartsReturnsInboundCountQuery>
export async function getPartsReturnsInboundCount(
  variables: GetPartsReturnsInboundCountQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetPartsReturnsInboundCountQuery['delivery_returns_aggregate'] | GetPartsReturnsInboundCountQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetPartsReturnsInboundCountQuery>(
    GetPartsReturnsInboundCountDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delivery_returns_aggregate
}